var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pepicons-pencil:dots-y"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.7998 10.8C4.7998 10.4817 4.92623 10.1765 5.15128 9.95147C5.37632 9.72643 5.68154 9.6 5.9998 9.6C6.31806 9.6 6.62329 9.72643 6.84833 9.95147C7.07338 10.1765 7.1998 10.4817 7.1998 10.8C7.1998 11.1183 7.07338 11.4235 6.84833 11.6485C6.62329 11.8736 6.31806 12 5.9998 12C5.68154 12 5.37632 11.8736 5.15128 11.6485C4.92623 11.4235 4.7998 11.1183 4.7998 10.8ZM4.7998 6C4.7998 5.68174 4.92623 5.37652 5.15128 5.15147C5.37632 4.92643 5.68154 4.8 5.9998 4.8C6.31806 4.8 6.62329 4.92643 6.84833 5.15147C7.07338 5.37652 7.1998 5.68174 7.1998 6C7.1998 6.31826 7.07338 6.62348 6.84833 6.84853C6.62329 7.07357 6.31806 7.2 5.9998 7.2C5.68154 7.2 5.37632 7.07357 5.15128 6.84853C4.92623 6.62348 4.7998 6.31826 4.7998 6ZM4.7998 1.2C4.7998 0.88174 4.92623 0.576515 5.15128 0.351472C5.37632 0.126428 5.68154 0 5.9998 0C6.31806 0 6.62329 0.126428 6.84833 0.351472C7.07338 0.576515 7.1998 0.88174 7.1998 1.2C7.1998 1.51826 7.07338 1.82348 6.84833 2.04853C6.62329 2.27357 6.31806 2.4 5.9998 2.4C5.68154 2.4 5.37632 2.27357 5.15128 2.04853C4.92623 1.82348 4.7998 1.51826 4.7998 1.2Z",
    fill: "white",
    fillOpacity: 0.87
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsMenu);
export default __webpack_public_path__ + "static/media/DotsMenu.7af50a1ad5ec9f5046ab83eef700ff2c.svg";
export { ForwardRef as ReactComponent };